import l1 from "../components/img/codeimg/l1.png";
import l2 from "../components/img/codeimg/l2.png";
import f1 from "../components/img/codeimg/f1.png";
import f2 from "../components/img/codeimg/f2.png";
import video from "../components/img/codeimg/video.mp4";

// Project cards data
export const projects = [
  {
    id: 1,
    title: "The Ledger",
    description:
      "The Ledger is a comprehensive mobile application built with React Native that transforms receipt management and budget tracking through advanced AI technology. Scan receipts, automatically categorize expenses, track budgets, and get intelligent spending insights.",
    mockupImage: l1,
    mockupImage2: l2,
    githubLink: "https://github.com/PHILLIP8264/slipscan.git",
    liveLink:
      "https://github.com/PHILLIP8264/slipscan/blob/main/previewdocuments/Screen_Recording_20251105_093737_The%20Ledger.mp4",
    technologies: ["React", "Node.js", "Firebase", "Gemini API"],
  },
  {
    id: 2,
    title: "FrameIt",
    description:
      "FrameIt is a revolutionary location-based social photography app that transforms the way you explore and document your world. Combining elements of gamification, social networking, and real-world exploration, FrameIt encourages users to venture beyond their comfort zones through engaging photo quests and challenges.",
    mockupImage: f1,
    mockupImage2: f2,
    githubLink: "https://github.com/PHILLIP8264/FrameIt.git",
    liveLink: video,
    technologies: ["React", "Firebase", "Firestore", "Expo", "Tailwind CSS"],
  },
];

export const githubProfile = {
  username: "yourusername",
  bio: "Full Stack Developer | Open Source Enthusiast",
  publicRepos: 45,
  followers: 250,
  following: 100,
  profileUrl: "https://github.com/yourusername",
};
